import React, { useState } from 'react';
import { ComplaintsList } from './ComplaintsList';
import { ComplaintReplyForm } from './ComplaintReplyForm';
import { type Complaint } from '../../services/complaintsService';

export function ComplaintsPage() {
  const [selectedComplaint, setSelectedComplaint] = useState<Complaint | null>(null);
  const [showReplyForm, setShowReplyForm] = useState(false);
  const [showViewForm, setShowViewForm] = useState(false);

  // Обработка просмотра жалобы
  const handleViewComplaint = (complaint: Complaint) => {
    setSelectedComplaint(complaint);
    setShowViewForm(true);
    setShowReplyForm(false);
  };

  // Обработка ответа на жалобу
  const handleReplyToComplaint = (complaint: Complaint) => {
    setSelectedComplaint(complaint);
    setShowReplyForm(true);
    setShowViewForm(false);
  };

  // Обработка успешного ответа
  const handleReplySuccess = () => {
    setShowReplyForm(false);
    setSelectedComplaint(null);
    // Список автоматически обновится через store
  };

  // Обработка закрытия форм
  const handleCloseForms = () => {
    setShowReplyForm(false);
    setShowViewForm(false);
    setSelectedComplaint(null);
  };

  return (
    <div className="bg-[#f5f6f1] box-border content-stretch flex flex-col gap-6 items-start justify-start p-[24px] relative rounded-[24px] shrink-0 w-full h-full overflow-hidden">
            {/* Основной контент */}
      <div className="w-full h-full min-h-0">
        {/* Список жалоб */}
        {!showReplyForm && !showViewForm && (
          <ComplaintsList
            onViewComplaint={handleViewComplaint}
            onReplyToComplaint={handleReplyToComplaint}
          />
        )}

        {/* Форма ответа */}
        {showReplyForm && selectedComplaint && (
          <div className="w-full h-full min-h-0">
            <ComplaintReplyForm
              complaint={selectedComplaint}
              onClose={handleCloseForms}
              onSuccess={handleReplySuccess}
            />
          </div>
        )}

        {/* Форма просмотра */}
        {showViewForm && selectedComplaint && (
          <div className="w-full h-full min-h-0">
            {/* Заголовок и кнопка назад */}
            <div className="flex items-center justify-between mb-6">
              <div className="css-sqkidj font-['Inter_Display:Medium',_sans-serif] leading-[0] not-italic relative shrink-0 text-[#000000] text-[24px] text-left text-nowrap">
                <p className="block leading-[30px] whitespace-pre">Жалоба #{selectedComplaint.id}</p>
              </div>
              <button
                onClick={handleCloseForms}
                className="transition-colors text-[15px] font-medium"
                style={{ color: 'var(--brand-primary, #e16349)' }}
              >
                ← Назад к списку
              </button>
            </div>
            
              <div className="space-y-6">
                {/* Информация о жалобе */}
                <div className="bg-[#ffffff] relative rounded-3xl shrink-0 w-full p-[24px] border border-[#e2e4e9]">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="box-border content-stretch flex flex-col gap-2 items-start justify-start p-0 relative shrink-0 w-full">
                      <label className="css-7dow9l font-['Inter:Medium',_sans-serif] font-medium leading-[0] not-italic relative shrink-0 text-[#000000] text-[14px] text-left w-full">
                        <p className="block leading-[20px]">ID</p>
                      </label>
                      <div className="text-[#525866] text-[14px] font-['Inter:Regular',_sans-serif]">#{selectedComplaint.id}</div>
                    </div>
                    <div className="box-border content-stretch flex flex-col gap-2 items-start justify-start p-0 relative shrink-0 w-full">
                      <label className="css-7dow9l font-['Inter:Medium',_sans-serif] font-medium leading-[0] not-italic relative shrink-0 text-[#000000] text-[14px] text-left w-full">
                        <p className="block leading-[20px]">Автор</p>
                      </label>
                      <div className="text-[#525866] text-[14px] font-['Inter:Regular',_sans-serif]">{selectedComplaint.author}</div>
                    </div>
                    <div className="box-border content-stretch flex flex-col gap-2 items-start justify-start p-0 relative shrink-0 w-full">
                      <label className="css-7dow9l font-['Inter:Medium',_sans-serif] font-medium leading-[0] not-italic relative shrink-0 text-[#000000] text-[14px] text-left w-full">
                        <p className="block leading-[20px]">Email</p>
                      </label>
                      <div className="text-[#525866] text-[14px] font-['Inter:Regular',_sans-serif]">{selectedComplaint.authorEmail}</div>
                    </div>
                    <div className="box-border content-stretch flex flex-col gap-2 items-start justify-start p-0 relative shrink-0 w-full">
                      <label className="css-7dow9l font-['Inter:Medium',_sans-serif] font-medium leading-[0] not-italic relative shrink-0 text-[#000000] text-[14px] text-left w-full">
                        <p className="block leading-[20px]">Тип</p>
                      </label>
                      <div className="text-[#525866] text-[14px] font-['Inter:Regular',_sans-serif]">{selectedComplaint.type}</div>
                    </div>
                    <div className="box-border content-stretch flex flex-col gap-2 items-start justify-start p-0 relative shrink-0 w-full">
                      <label className="css-7dow9l font-['Inter:Medium',_sans-serif] font-medium leading-[0] not-italic relative shrink-0 text-[#000000] text-[14px] text-left w-full">
                        <p className="block leading-[20px]">Статус</p>
                      </label>
                      <div className="text-[#525866] text-[14px] font-['Inter:Regular',_sans-serif]">
                        {selectedComplaint.status === 'new' ? 'Новая' :
                         selectedComplaint.status === 'in_progress' ? 'В работе' : 'Закрыта'}
                      </div>
                    </div>
                    <div className="box-border content-stretch flex flex-col gap-2 items-start justify-start p-0 relative shrink-0 w-full">
                      <label className="css-7dow9l font-['Inter:Medium',_sans-serif] font-medium leading-[0] not-italic relative shrink-0 text-[#000000] text-[14px] text-left w-full">
                        <p className="block leading-[20px]">Дата создания</p>
                      </label>
                      <div className="text-[#525866] text-[14px] font-['Inter:Regular',_sans-serif]">
                        {new Date(selectedComplaint.createdAt).toLocaleDateString('ru-RU', {
                          day: '2-digit',
                          month: '2-digit',
                          year: 'numeric',
                          hour: '2-digit',
                          minute: '2-digit'
                        })}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Описание жалобы */}
                <div className="box-border content-stretch flex flex-col gap-2 items-start justify-start p-0 relative shrink-0 w-full">
                  <label className="css-7dow9l font-['Inter:Medium',_sans-serif] font-medium leading-[0] not-italic relative shrink-0 text-[#000000] text-[14px] text-left w-full">
                    <p className="block leading-[20px]">Описание жалобы</p>
                  </label>
                  <div className="bg-[#ffffff] relative rounded-3xl shrink-0 w-full p-[24px] border border-[#e2e4e9] min-h-[100px]">
                    <div className="text-[#525866] text-[14px] font-['Inter:Regular',_sans-serif] whitespace-pre-wrap">
                      {selectedComplaint.description}
                    </div>
                  </div>
                </div>

                {/* Ответ на жалобу (если есть) */}
                {selectedComplaint.reply && (
                  <div className="box-border content-stretch flex flex-col gap-2 items-start justify-start p-0 relative shrink-0 w-full">
                    <label className="css-7dow9l font-['Inter:Medium',_sans-serif] font-medium leading-[0] not-italic relative shrink-0 text-[#000000] text-[14px] text-left w-full">
                      <p className="block leading-[20px]">Ответ</p>
                    </label>
                    <div className="bg-[#ffffff] relative rounded-3xl shrink-0 w-full p-[24px] border border-[#e2e4e9] min-h-[100px]">
                      <div className="text-[#525866] text-[14px] font-['Inter:Regular',_sans-serif] whitespace-pre-wrap">
                        {selectedComplaint.reply}
                      </div>
                    </div>
                    {selectedComplaint.repliedAt && (
                      <div className="text-[#868c98] text-[12px] font-['Inter:Regular',_sans-serif] mt-2">
                        Ответ дан: {new Date(selectedComplaint.repliedAt).toLocaleDateString('ru-RU', {
                          day: '2-digit',
                          month: '2-digit',
                          year: 'numeric',
                          hour: '2-digit',
                          minute: '2-digit'
                        })}
                      </div>
                    )}
                  </div>
                )}

                {/* Кнопки действий */}
                {!selectedComplaint.reply && (
                  <div className="box-border content-stretch flex flex-row gap-3 items-center justify-end p-0 relative shrink-0 w-full">
                    <button
                      onClick={() => {
                        setShowViewForm(false);
                        setShowReplyForm(true);
                      }}
                      className="text-white p-[16px] h-[52px] rounded-3xl transition-colors font-['Inter:Medium',_sans-serif] font-medium leading-[0] not-italic relative shrink-0 text-[16px] text-center tracking-[-0.176px] px-[24px]"
                      style={{ backgroundColor: 'var(--brand-primary, #e16349)' }}
                    >
                      Ответить
                    </button>
                  </div>
                )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
